import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type GovReportingFacilityRecord = QueryAtomResult<
  typeof queryGovReportingFacilitiesAtom
>[number];

export const queryGovReportingFacilitiesAtom = createQueryAtomFactory(
  'settings.govReportingFacilities',
  ({ configurationId }: { configurationId: string }) => ({
    governmentReportingFacilities: {
      __args: {
        filter: {
          governmentReportingConfigurationId: configurationId,
        },
        pagination: {
          offset: 0,
          limit: 100,
        },
      },
      entries: {
        id: true,
        governmentReportingConfigurationId: true,
        facilityId: true,
        reportingFacilityId: true,
        mlid: true,
        facility: {
          id: true,
          facilityName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.governmentReportingFacilities.entries.map((facility) => ({
        id: facility.id,
        governmentReportingConfigurationId:
          facility.governmentReportingConfigurationId,
        facilityId: facility.facilityId,
        reportingFacilityId: facility.reportingFacilityId,
        mlid: facility.mlid,
        facilityName: facility.facility?.facilityName ?? '',
        createdAt: facility.timestamps.createdAt,
        updatedAt: facility.timestamps.updatedAt,
      })) ?? [],
  },
);
